//External
import React from "react";
import Link from "next/link";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { get_cookie } from "utils";

/*******************
  @Purpose :  used for Brand vehicle
  @Parameter : {brandCategorydetail, vehicleName, slug1, slug2, vehicleSlug, }
  @Author : INIC
 *******************/
function Breadcrumbs({
  brandCategorydetail,
  vehicleName,
  slug1,
  slug2,
  vehicleSlug,
  categoryDetail,
}) {
  const is_mobile_app = get_cookie("is_mobile_app");

  /*******************
  @Purpose : used for home click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const homeClickRedirect = () => {
    let path = "";
    const r = get_cookie("redirectUrl");
    if (r) {
      path = r;
    } else {
      path = "/";
    }
    return path;
  };

  let selectedCityName = "Los Angeles";
  if (get_cookie("selectedCityName")) {
    selectedCityName = get_cookie("selectedCityName");
  }

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <Breadcrumb className="breadcrumb-content">
      {is_mobile_app !== "yes" && (
        <>
          <Link href={homeClickRedirect()}>
            <Breadcrumb.Item href={homeClickRedirect()}>
              {selectedCityName}
            </Breadcrumb.Item>
          </Link>
          {typeof vehicleName !== "undefined" ? (
            <>
              <Link href={"/" + slug1 + "/" + slug2 + "/" + vehicleSlug}>
                <Breadcrumb.Item
                  href={"/" + slug1 + "/" + slug2 + "/" + vehicleSlug}
                >
                  {brandCategorydetail?.title}
                </Breadcrumb.Item>
              </Link>
              {categoryDetail && (
                <Link
                  href={"/" + slug1 + "/" + slug2 + "/" + categoryDetail?.slug}
                >
                  <Breadcrumb.Item
                    href={
                      "/" + slug1 + "/" + slug2 + "/" + categoryDetail?.slug
                    }
                  >
                    {categoryDetail?.title}
                  </Breadcrumb.Item>
                </Link>
              )}
              {/*               <Breadcrumb.Item active>{vehicleName}</Breadcrumb.Item>
               */}{" "}
            </>
          ) : (
            <>
              <Breadcrumb.Item active>
                {brandCategorydetail?.title}
              </Breadcrumb.Item>
            </>
          )}
        </>
      )}
    </Breadcrumb>
  );
}
export default Breadcrumbs;
